import React from 'react';
import Button from 'react-bootstrap/Button';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import hotelcss from '../pages/css/hotelhotellist.module.css';

import CountrieSelection from '../customNodes/CountriesSelection';
import HotelSelection from '../customNodes/HotelSelection';
import RegionSelection from '../customNodes/RegionSelection';
import EmployeeHolidaysListNode from '../customNodes/EmployeeHolidaysListNode';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getserverurl, getView, getfilestoragelocation } from '../dbconnector/connector';
import { MdDelete } from "react-icons/md";

import { MdFileDownload } from "react-icons/md";
import { MdEdit } from "react-icons/md";
import { FaAngleLeft } from "react-icons/fa6";
import { FaAnglesLeft } from "react-icons/fa6";
import { FaAngleRight } from "react-icons/fa6";
import { FaAnglesRight } from "react-icons/fa6";
import { deleteEmployee, getemployers, deleteZiektebriefje } from "../dbconnector/connector";
import { format } from "date-fns";

import { useState } from 'react';
import { useEffect } from 'react';
import { downloadfile, getfilesurl, deletefile, CheckFileExists } from "../tools/filehandler";
import { confirmAlert } from 'react-confirm-alert';
import FileViewer from '../customNodes/FileViewer.js'
import { Tooltip } from 'react-tooltip'
import { TreeView, TreeItem } from '../customNodes/Treeview.js';
import AddDocumentType from '../customNodes/AddDocumentType';
import AddDoctorsNote from '../customNodes/AddDoctorsNote';
import { FaFolderPlus } from 'react-icons/fa';
import { TiDocumentAdd } from "react-icons/ti";
import { FaRegEye } from "react-icons/fa";
import DocViewer from "react-doc-viewer";
import moment, { now } from "moment";

import CurrencyInput from 'react-currency-input-field';

import { setErrorMessage } from '../tools/errorhandling';
import {
    getZiektebriefjes
} from "../dbconnector/connector";
import TimePicker from '@ashwinthomas/react-time-picker-dropdown';




const EmployeeNode = ({ rights, translation, isDisabled, hotelsarray, data, events, displaytabs, disabledtabs, defaulttab, viewOnly, employersarray }) => {
    const [key, setKey] = useState('home');
    const [documenttypes, setDocumenttypes] = useState([]);
    const [contractTabRendered, setContractTabRendered] = useState(false);
    const [filenameArray, setFilenameArray] = useState([]);
    const [documentsarray, setDocumentsArray] = useState([]);
    //const [employersarray, setEmployersarray] = useState([]);
    const [selectedtab, setSelectedtab] = useState(0);
    const [idcard, setIdcard] = useState(null);
    const [filecounter, setfilecounter] = useState(0);
    const [deleting, setdeleting] = useState(false);
    const [documenttree, setdocumenttree] = useState([]);
    const [typeid, settypeid] = useState(null);
    const [typedescription, settypedescription] = useState(null);

    const [treeloaded, setTreeloaded] = useState(false);
    const t = translation
    const docs = [{ uri: "no file selected" }];
    const [serverurl, setfilesurl] = useState(getfilestoragelocation());
    const [ziektearray, setZiekteArray] = useState([]);
    const [ziekte, setZiekte] = useState([]);
    const [selectedZiekte, setSelectedZiekte] = useState({});

    useEffect(() => {
        //console.log("insidenode-", employersarray)
    }, [employersarray])

    const renderSubtrees = (trees, user) => {
        if (trees !== undefined) {
            return trees.map((tree) => {
                ////////console.log(tree)
                if (tree.subtrees !== undefined && !tree.subtrees.length) {
                    return <TreeItem rights={rights} translation={translation} user={user} key={tree.id} id={tree.id} title={tree.name} dateuploaded={tree.dateuploaded} folder={tree.folder} type={tree.type} events={{ getdocumentlist: getdocumentlist, loaddocumenttypes: loaddocumenttypes, cleariframe: cleariframe, setId: events.setId, onSubmit: events.onSubmit, EditdocumentType: EditdocumentType }} />;
                }
                return (
                    <TreeItem rights={rights} translation={translation} user={user} key={tree.id} id={tree.id} title={tree.name} dateuploaded={tree.dateuploaded} folder={tree.folder} type={tree.type} events={{ getdocumentlist: getdocumentlist, loaddocumenttypes: loaddocumenttypes, cleariframe: cleariframe, setId: events.setId, onSubmit: events.onSubmit, EditdocumentType: EditdocumentType }}>
                        {renderSubtrees(tree.subtrees, user)}
                    </TreeItem>
                );
            });
        }
    };
    useEffect(() => {

        if (document.getElementById("geslacht_1")) {
            if (data.user.geslacht >= 1 && data.user.geslacht <= 3) {
                let radioButton;
                radioButton = document.getElementById("geslacht_1");
                radioButton.checked = false;
                radioButton = document.getElementById("geslacht_2");
                radioButton.checked = false;
                radioButton = document.getElementById("geslacht_3");
                radioButton.checked = false;
                radioButton = document.getElementById("geslacht_" + data.user.geslacht.toString());
                if (radioButton) {
                    radioButton.checked = true;
                }
            }
        }
    }, [data.user.geslacht]);

    useEffect(() => {
        //setEmployersarray([])

        //if (data.user.id !== undefined) {
        setDocumenttypes([])
        setSelectedtab(Number(sessionStorage.getItem('selectedusertabid')))
        //LoadEmployers();
        reloadfiles();
        loaddocumenttypes();
        LoadDoctorsNotes(data.user.id)
        //}else{

        // LoadEmployers();  
        // }
    }, [data.user.id]);

    const LoadDoctorsNotes = async (id) => {
        setZiekte({})
        setZiekteArray([])
        const ziektebriefjes = getZiektebriefjes(id)
        ziektebriefjes.then(res => {
            res.json().then(res => {
                setZiekte(res)
            })
        })

    }

    useEffect(() => {
        if (documenttypes !== undefined && documenttypes.length > 0) {
            getdocumentlist()
        }
    }, [documenttypes]);

    const setcontractTabRendered = (value, tabid) => {
        setContractTabRendered(value)
        setSelectedtab(tabid)
        sessionStorage.setItem('selectedusertabid', tabid)
    }
    const cleariframe = () => {
        document.getElementById("displayedfileName").innerText = "";
        //if(document.getElementById("displayedziektefileName") !== undefined)
        //    document.getElementById("displayedziektefileName").innerText = "";
        document.getElementById("embedtag_new").src = ""
       // document.getElementById("embedtag_ziekte").src = ""
        //embedtag_ziekte
    }
    const cleardoctorsnoteiframe = () => {
        document.getElementById("displayedziektefileName").innerText = "";
       document.getElementById("embedtag_ziekte").src = ""
    }
    const adddocumentType = () => {
        settypeid(null)
        settypedescription(null)
        document.getElementById("coverAll").style.display = 'block'
        document.getElementById("add_doctorsnote").style.display = 'none'
        document.getElementById("add_documenttype").style.display = 'block'
    }
    const addziektebriefje = () => {
        setSelectedZiekte({})
        // setSelectedZiekte(
        //     {
        //          Id:null
        //     //     ziek_van: ziek_van,
        //     //     ziek_tot: ziek_tot,
        //     //     filelink: newfileid.id,
        //     //     filename: newfileid.url,
        //     //     werknemer_id: user.id
        //     // }
        // })
        document.getElementById("coverAll").style.display = 'block'
        document.getElementById("add_doctorsnote").style.display = 'block'
        document.getElementById("add_documenttype").style.display = 'none'
    }
    const EditZiektebriefje = (data) => {
        setSelectedZiekte({})
        setSelectedZiekte(data)
        //console.log(data)
        document.getElementById("coverAll").style.display = 'block'
        document.getElementById("add_doctorsnote").style.display = 'block'
        document.getElementById("add_documenttype").style.display = 'none'
    }

    const EditdocumentType = (id, description) => {
        settypeid(id)
        settypedescription(description)
        document.getElementById("coverAll").style.display = 'block'
    }
    const loaddocumenttypes = () => {
        setDocumenttypes([])
        const treearray = [];
        const fields = '["documentlist"]';
        const values = `[${1}]`;
        getView("documenttypeslist", fields, values).then((res) => {
            if (res.status === 200) {
                res.json().then(body => {
                    if (body.length > 0) {
                        body.forEach((item, index) => {
                            treearray.push(
                                {
                                    id: item.id,
                                    name: item.name,
                                    folder: true,
                                    subtrees: [
                                    ]
                                }
                            )
                        })
                        setDocumenttypes(treearray)
                    }
                })
            }
        })
    }
    const setselectedtab = (tabid) => {
        setSelectedtab(tabid)
        sessionStorage.setItem('selectedusertabid', tabid)
    }
    const loaddocument = (e) => {
        let docs = { uri: serverurl + e.target.id }
        document.getElementById("embedtag_new").src = docs.uri
    }

    const loadziektebriefje = (filename) => {
        //console.log(filename.filename)
        let docs = { uri: serverurl + filename.filename }
        document.getElementById("displayedziektefileName").innerText = "Ziektebriefje: '" + filename.filename + "' | => Opgeladen op: '" + moment(filename.UploadDate).format("DD-MMM-YYYY") + "'";
        document.getElementById("embedtag_ziekte").src = docs.uri
    }
    // const Editziektebriefje = (id, description) => {
    //     settypeid(id)
    //     settypedescription(description)
    //     document.getElementById("coverAll").style.display = 'block'
    // }
    const getdocumentlist = () => {
        if (data.user.id !== undefined & rights > 1) {
            const fields = '["link_Id"]';
            const values = `[${data.user.id}]`;
            getView("user_uploaded_documents", fields, values).then((res) => {
                if (res.status === 200) {
                    res.json().then(body => {
                        if (body.length > 0) {
                            setDocumentsArray([]);
                            body.forEach((item, index) => {
                                //if (CheckFileExists(item.filename)) {
                                if (documenttypes.find((doctype) => Number(doctype.id) === Number(item.type)) !== undefined)
                                    documenttypes.find((doctype) => Number(doctype.id) === Number(item.type)).subtrees.push({ id: item.filename, name: item.filename.substring(13), dateuploaded: format(item.creationDatetime, "dd MMM yyyy HH:mm"), folder: false, type: item.type })
                                setDocumentsArray(pre => [...pre,
                                <div id={index} className={index % 2 === 0 ? hotelcss.documentlinkVarient1 : hotelcss.documentlinkVarient2}>
                                    <a id={item.filename} onClick={loaddocument} value={item.filename}>{item.filename !== null && item.filename.length > 13 ? item.filename.substring(13) : item.filename}</a>
                                    <a id={item.filename} onClick={loaddocument} value={item.filename}>{item.type === "1" ? "Id bewijs" : "contract"}</a>
                                    <a id={item.filename} onClick={loaddocument} value={item.filename}>{format(item.creationDatetime, "dd MMM yyyy HH:mm")}</a>
                                    <a id={item.filename} onClick={() => deletedocument(item.filename)} value={item.filename} style={rights === 2 ? { display: "block" } : { display: "none" }}><MdDelete></MdDelete></a>
                                </div>
                                ])
                                //}
                            })
                        }
                    })
                } else {
                    setErrorMessage(res.statusText)
                }
            })
        }
        setdocumenttree(documenttypes)
        setTreeloaded(true)
    }

    const reloadfiles = () => {
        getfilesurl(1, data.user.id).then((data) => {
            //////console.log("returned data :", data);
            if (data.length < 1) {
                setIdcard(null);
            }
            setfilecounter(0);
            setFilenameArray(data);
        })
    }

    useEffect(() => {
        if (filenameArray.length > 0) {

            setIdcard(filenameArray[filecounter]);
            //////console.log("idlink", filenameArray[filecounter]);
        }
    }, [filenameArray, filecounter]);

    useEffect(() => {
        if (ziekte.length > 0) {
            console.log("ddddddddddddddddddddddddddddddddddddddddd")
            setZiekteArray([]);
            ziekte.forEach((item, index) => {
                //console.log(item)
                setZiekteArray(pre => [...pre,
                <div id={item.Id} className={index % 2 === 0 ? hotelcss.ziektelinkVarient1 : hotelcss.ziektelinkVarient2} >
                    <p></p>
                    <div onClick={() => loadziektebriefje(item)}>{moment(item.UploadDate).format("DD-MM-YYYY")}</div>
                    <div onClick={() => loadziektebriefje(item)}>{moment(item.ziek_van).format("DD-MM-YYYY")}</div>
                    <div onClick={() => loadziektebriefje(item)}>{moment(item.ziek_tot).format("DD-MM-YYYY")}</div>
                    <div style={rights === 2 ? { display: 'block' } : { display: 'none' }}><MdDelete onClick={() => deleteziektebriefje(item, 12)} className={hotelcss.ziekteicon}></MdDelete></div>
                    <div style={rights === 2 ? { display: 'block' } : { display: 'none' }}><MdEdit onClick={() => EditZiektebriefje(item, "")} className={hotelcss.ziekteicon} /></div>

                </div>
                ])
            })
        }

    }, [ziekte]);

    useEffect(() => {
        if (document.getElementById("contracttype_1")) {
            let radioButton;
            if (data.user.contracttype >= 1 && data.user.contracttype <= 2) {
                radioButton = document.getElementById("contracttype_1");
                radioButton.checked = false;
                radioButton = document.getElementById("contracttype_2");
                radioButton.checked = false;
                radioButton = document.getElementById("contracttype_" + data.user.contracttype.toString());
                if (radioButton) {
                    radioButton.checked = true;
                }
            }
        }
    }, [data.user.contracttype, contractTabRendered]);

    useEffect(() => {
        if (document.getElementById("contractlooptijd_1")) {
            let radioButton;
            if (data.user.contractlooptijd === undefined) {
                document.getElementById("OutService").style.display = "none";
            }
            if (data.user.contractlooptijd >= 1 && data.user.contractlooptijd <= 3) {
                radioButton = document.getElementById("contractlooptijd_1");
                radioButton.checked = false;
                radioButton = document.getElementById("contractlooptijd_2");
                radioButton.checked = false;
                radioButton = document.getElementById("contractlooptijd_3");
                radioButton.checked = false;
                radioButton = document.getElementById("contractlooptijd_" + data.user.contractlooptijd.toString());
                if (radioButton) {
                    radioButton.checked = true;
                }

                if (data.user.contractlooptijd === 2) {
                    document.getElementById("OutService").style.display = "block";
                }
                if (data.user.contractlooptijd === 3) {
                    document.getElementById("OutService").style.display = "block";
                }
                if (data.user.contractlooptijd === 1) {
                    document.getElementById("OutService").style.display = "none";
                }
            }
        }
    }, [data.user.contractlooptijd, contractTabRendered]);

    const handlefirstcontract = () => {
        setfilecounter(pre => {
            return 0;
        });
    }

    const handlelastcontract = () => {
        setfilecounter(pre => {
            return filenameArray.length - 1;
        });
    }

    const handlenextcontract = () => {
        setfilecounter(pre => {
            if (pre + 1 >= filenameArray.length) {
                return 0;
            }
            return pre + 1;
        });
    }

    const handleprevcontract = () => {
        setfilecounter(pre => {
            if (pre - 1 < 0) {
                return filenameArray.length - 1;
            }
            ////////////console.log(pre)
            return pre - 1;
        });
    }

    const openfile = () => {
        window.open(filenameArray[filecounter], '_blanc')
    }

    const deletefilehandler = () => {
        ////////console.log(filenameArray[filecounter].split("/").pop())
        ////////console.log(filenameArray[filecounter].type)
        const options = {
            title: t('Delete?'),
            message: t('SURETODELETEFILE'),

            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {

                        deletefile(filenameArray[filecounter].split("/").pop(), filenameArray[filecounter].type).then((res) => {
                            reloadfiles();
                            setdeleting(false);
                        })
                    }
                },
                {
                    label: 'No',
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
            overlayClassName: "overlay-custom-class-name"
        };

        if (deleting === false) {
            setdeleting(true);
            confirmAlert(options);

        }

    }


    const deleteziektebriefje = (doctorsnote, type) => {
        ////////console.log(filenameArray[filecounter].split("/").pop())
        ////////console.log(filenameArray[filecounter].type)
        //console.log("ddddddddddddddddd", doctorsnote)

        const options = {
            title: t('Delete?'),
            message: t('SURETODELETEFILEDOCTORSNOTE'),

            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {

                        deletefile(doctorsnote.filename, type).then((res) => {
                            setdeleting(false);
                            deleteZiektebriefje(doctorsnote).then((res) => {
                                LoadDoctorsNotes(data.user.id)
                            })

                        })

                    }
                },
                {
                    label: 'No',
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
            overlayClassName: "overlay-custom-class-name"
        };

        if (deleting === false) {
            cleardoctorsnoteiframe()
            setdeleting(true);
           
            confirmAlert(options);

        }

    }



    function deletedocument(uri) {
        let filename = uri;
        if (uri !== null && uri.length > 13) {
            filename = uri.substring(13)
        }
        //////console.log("filename: ", filename)
        const options = {
            title: t("Delete?"),
            message: t("message_deleteDocument") + filename + t("message_deleteRoom_2"),
            buttons: [
                {
                    label: t("Yes"),
                    // onClick: () => {
                    //     const response = deleteEmployee(data.user.id);
                    //     response.then(res => {
                    //         if (res.ok) {
                    //             events.navigateback();
                    //         } else {
                    //             setErrorMessage(res.statusText);
                    //         }
                    //     });
                    // }
                },
                {
                    label: t("No"),
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
        };
        confirmAlert(options);
    };

    function deleteemp() {
        const options = {
            title: t("Delete?"),
            message: t("message_deleteEmployee_1") + data.user.voornaam + " " + data.user.achternaam + t("message_deleteRoom_2"),
            buttons: [
                {
                    label: t("Yes"),
                    onClick: () => {
                        const response = deleteEmployee(data.user.id);
                        response.then(res => {
                            if (res.ok) {
                                events.navigateback();
                            } else {
                                setErrorMessage(res.statusText);
                            }
                        });
                    }
                },
                {
                    label: t("No"),
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
        };
        confirmAlert(options);
    };


    return (
        <>


            <form className="form" onSubmit={events.onSubmit} autoComplete="off" >
                <input style={{ display: 'none' }} name="email" value="randomgeneratevalue" />
                <input type="password" style={{ display: 'none' }} />
                <label className='formtitleContentBox'>{t('GeneralData')}</label>
                <br></br>
                <div className="contentbox">

                    <Button className="deletebutton" onClick={deleteemp} style={rights !== 2 || viewOnly === true ? { display: "none" } : null}>  <MdDelete></MdDelete></Button>
                    <div className="formElement" style={rights !== 2 ? { display: "none" } : null}>
                        <label className='labelcolor'>
                            {t('Active')}:
                        </label>
                        <input id="userActive" type='checkBox' className="checkbox" value={data.user.actief} name="actief" onChange={events.changecheckbox} checked={data.user.actief} disabled={isDisabled}></input>

                    </div>
                    <div className="formElement formElementfieldset" style={rights !== 2 ? { display: "none" } : null}>
                        <label className='labelcolor'>
                            {t('Gender')}:
                        </label>
                        <fieldset className="fieldset" onChange={events.changevalue} disabled={isDisabled}>
                            <input type="radio" id="geslacht_1" name="geslacht" value="1" className="radio" />
                            <label for="geslacht_1" className="radiolabel"> {t('Male')}</label>

                            <input type="radio" id="geslacht_2" name="geslacht" value="2" className="radio" />
                            <label for="geslacht_2" className="radiolabel"> {t('Female')}</label>

                            <input type="radio" id="geslacht_3" name="geslacht" value="3" className="radio" />
                            <label for="geslacht_3" className="radiolabel"> {t('X')}</label>
                        </fieldset>
                    </div>
                    <div className="formElement">
                        <label className='labelcolor'>
                            {t('FirstName')}:
                        </label>
                        <input id='voornaam' type='text' name="voornaam" value={data.user.voornaam} onChange={events.changevalue} disabled={isDisabled}></input>
                    </div>
                    <div className="formElement">
                        <label className='labelcolor'>
                            {t('LastName')}:
                        </label>
                        <input id="achternaam" type='text' name="achternaam" value={data.user.achternaam} onChange={events.changevalue} disabled={isDisabled}></input>
                    </div>
                    <div className="formElement">
                        <label className='labelcolor'>
                            {t('WKNNum')}
                        </label>
                        <input id="nr_wkn" type='number' name="nr_wkn" value={data.user.nr_wkn} onChange={events.changevalue} disabled={isDisabled}></input>
                    </div></div>    <br></br>
                <Tabs className="HotelTabs" value="tab_2" defaultIndex={defaulttab} selectedIndex={selectedtab} >
                    <TabList defaultActiveKey="tab_2">
                        <Tab style={displaytabs.tab1 === false ? { display: 'none' } : null} eventKey="tab_1" disabled={disabledtabs.tab1} onClick={() => setselectedtab(0)}>{t('Loggin')}</Tab>
                        <Tab style={displaytabs.tab2 === false ? { display: 'none' } : null} eventKey="tab_2" disabled={disabledtabs.tab2} onClick={() => setselectedtab(1)}>{t('PersonalInfo')}</Tab>
                        <Tab style={displaytabs.tab3 === false ? { display: 'none' } : null} eventKey="tab_3" disabled={disabledtabs.tab3} onClick={() => setselectedtab(2)}>{t('Address')}</Tab>
                        <Tab style={displaytabs.tab4 === false ? { display: 'none' } : null} eventKey="tab_4" disabled={disabledtabs.tab4} onClick={() => setcontractTabRendered(!contractTabRendered, 3)}>{t('ContractData')}</Tab>
                        <Tab style={displaytabs.tab5 === false ? { display: 'none' } : null} eventKey="tab_5" disabled={disabledtabs.tab5} onClick={() => setselectedtab(4)}>{t('Hotels')}</Tab>
                        <Tab style={displaytabs.tab7 === false ? { display: 'none' } : null} eventKey="tab_7" disabled={disabledtabs.tab7} onClick={() => setselectedtab(5)}>{t('Holidays')}</Tab>
                        <Tab style={displaytabs.tab8 === false ? { display: 'none' } : null} eventKey="tab_8" disabled={disabledtabs.tab8} onClick={() => setselectedtab(6)}>{t('Documenten')}</Tab>
                        <Tab style={displaytabs.tab9 === false ? { display: 'none' } : null} eventKey="tab_9" disabled={disabledtabs.tab9} onClick={() => setselectedtab(7)}>{t('Ziekte')}</Tab>
                        {/* <Tab style={displaytabs.tab9 === false ? { display: 'none' } : null} eventKey="tab_9" disabled={disabledtabs.tab9} onClick={() => setselectedtab(7)}>{t('Documenten')}</Tab> */}
                    </TabList>
                    <TabPanel id="tabpanel_1" style={displaytabs.tab1 === false ? { display: 'none' } : null} defaultActiveKey="first">
                        <div className='tabpanel UserTabs' id="Account">
                            <div className="formElement">
                                <label>
                                    {t('Email')}:
                                </label>
                                <input id="email" type='email' name="email" value={data.user.email} onChange={events.changevalue} disabled={isDisabled} autocomplete="cc-csc" input=""></input>
                            </div>
                            <div className="formElement" style={rights !== 2 ? { display: "none" } : null}>
                                <label>
                                    {t('Paswoord')}:
                                </label>
                                <input id="paswoord" type='password' name="paswoord" value={data.user.password} onChange={events.changevalue} autocomplete="cc-csc" disabled={isDisabled}></input>
                            </div>
                            <div className="formElement">
                                <label>
                                    {t('Profiel')}:
                                </label>
                                <select id='profile' name="FK_Rechten_ID" value={data.user.FK_Rechten_ID} onChange={events.changevalue} disabled={isDisabled}>
                                    <option >---Selecteer Profiel---</option>
                                    <option value={2}>{t('Administrator')}</option>
                                    <option value={3}>{t('Supervisor')}</option>
                                    <option value={1}>{t('Cleaner')}</option>
                                    <option value={4}>{t('overhead')}</option>
                                </select>
                            </div>
                            <div className="formElement">
                                <label>
                                    {t('Geolocation')}:
                                </label>
                                <input id="useGeolocation" type='checkBox' className="checkbox" value={data.user.geolocation} name="geolocation" onChange={events.changecheckbox} checked={data.user.geolocation} disabled={isDisabled}></input>
                            </div>
                            <div className="formElement">
                                <label>
                                    {t('canmodifyapprovedschedules')}:
                                </label>
                                <input id="canmodifyapprovedschedules" type='checkBox' className="checkbox" value={data.user.canmodifyapprovedschedules} name="canmodifyapprovedschedules" onChange={events.changecheckbox} checked={data.user.canmodifyapprovedschedules} disabled={isDisabled}></input>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel id="tabpanel_2" style={displaytabs.tab2 === false ? { display: 'none' } : null} defaultActiveKey="second">
                        <div className='tabpanel personalinfotabsplit'>
                            <div className='UserTabs' id="Extra info">
                                <div className="formElement">
                                    <label>
                                        {t('RRN')}:
                                    </label>
                                    <input id="rijksregisternummer" type='text' name="rijksregisternummer" value={data.user.rijksregisternummer} onChange={events.changevalue} disabled={isDisabled}></input>
                                </div>
                                <div className="formElement">
                                    <label>
                                        {t('DateOfBirth')}:
                                    </label>
                                    <DatePicker className='datepicker' placeholderText="dd/MM/yyyy" selected={data.user.geboortedatum} onChange={(e) => events.changedate(e, "geboortedatum")} showIcon name="geboortedatum" dateFormat="dd/MM/yyyy" disabled={isDisabled} />
                                </div>
                                <div className="formElement" style={rights !== 2 ? { display: "none" } : null}>
                                    <label>
                                        {t('Regio')}:
                                    </label>
                                    <RegionSelection isDisabled={isDisabled} data={{ disabled: { isDisabled }, fieldname: "region", selectedregion: data.user.region, handleitemchange: events.changevalue }} valueneeded="region" />
                                </div>
                                <div className="formElement" style={rights !== 2 ? { display: "none" } : { display: "block" }}>
                                    <label>
                                        {t('NR_Dep')}:
                                    </label>
                                    <HotelSelection isDisabled={isDisabled} data={{ disabled: { isDisabled }, fieldname: "nr_afd", selectedhotel: data.user.nr_afd, handleitemchange: events.changevalue }} valueneeded="afd_nr" css="selectwidthForMyDataHotel" />
                                </div>
                                <div className="formElement">
                                    <label>
                                        {t('BankAccount')}:
                                    </label>
                                    <input id="bankrekeningnummer" type='text' name="bankrekeningnummer" value={data.user.bankrekeningnummer} onChange={events.changevalue} disabled={isDisabled}></input>
                                </div>
                                <div className="formElement" style={rights !== 2 ? { display: "none" } : { display: "block" }}>
                                    <label>
                                        {t('ID-nummer')}:
                                    </label>
                                    <input id="idnummer" type='text' name="idnummer" value={data.user.idnummer} onChange={events.changevalue} disabled={isDisabled}></input>
                                </div>
                                <div className="formElement" style={rights !== 2 ? { display: "none" } : { display: "block" }}>
                                    <label>
                                        {t('Ingangsdatum')}:
                                    </label>
                                    <DatePicker className='datepicker' placeholderText="dd/mm/yyyy" selected={data.user.ingangsdatum_id} onChange={(e) => events.changedate(e, "ingangsdatum_id")} showIcon name="ingangsdatum_id" dateFormat="dd/MM/yyyy" id="ingangsdatum_id" disabled={isDisabled} />
                                    {/* <input id="geboortedatum" className='date' type='date' name="geboortedatum" value={formatDateToYYYYMMDD(new Date(data.user.geboortedatum))} onBlur={events.changevalue} disabled={isDisabled}></input> */}
                                </div>
                                <div className="formElement" style={rights !== 2 ? { display: "none" } : { display: "block" }}>
                                    <label>
                                        {t('Afloopdatum')}:
                                    </label>
                                    <DatePicker className='datepicker' placeholderText="dd/mm/yyyy" selected={data.user.afloopdatum_id} onChange={(e) => events.changedate(e, "afloopdatum_id")} showIcon name="afloopdatum_id" id="afloopdatum_id" dateFormat="dd/MM/yyyy" disabled={isDisabled} />

                                    {/* <input id="geboortedatum" className='date' type='date' name="geboortedatum" value={formatDateToYYYYMMDD(new Date(data.user.geboortedatum))} onBlur={events.changevalue} disabled={isDisabled}></input> */}
                                </div>
                                <div className="formElement" style={rights !== 2 ? { display: "none" } : { display: "block" }}>
                                    <label>
                                        {t('idCard')}:
                                    </label>
                                    <input className='cardpicker' id="uploadContract" multiple type='file' accept='*.*' onChange={(e) => { events.setId(pre => [...pre, ...e.target.files]); const contract = document.getElementById("viewcontractButton"); if (contract) { contract.disabled = true } }} disabled={data.user.id === undefined ? true : isDisabled}></input>
                                </div>
                                {/* <div id="idcardsview" className='UserTabs idcardtablesplit' style={viewOnly === true ? { display: "block" } : { display: "none" }}>
                                    <label>
                                        {t('idCard')}:
                                    </label>
                                    <div id="previewview" className='kader' style={data.user.id === undefined ? { visibility: "hidden" } : { visibility: "visible" }}>
                                        <img src={idcard} style={{
                                            width: "95%",
                                            height: "200px",
                                            objectFit: "contain",
                                            border: "0px solid #ccc", // optional: nice border
                                            display: "block", // no inline weirdness
                                        }} title="idcard" className='preview'>

                                        </img>
                                      
                                        <center>
                                            <div className='navbuttons'>
                                                <FaAnglesLeft id="first_img" onClick={handlefirstcontract} className="deletefile">{"<"}</FaAnglesLeft >
                                                <FaAngleLeft id="prev_img" onClick={handleprevcontract} className="deletefile">{"<"}</FaAngleLeft>
                                                <MdFileDownload id="open_img" onClick={openfile} className="deletefile"></MdFileDownload> 
                                                <MdDelete id="delete_img" onClick={deletefilehandler} className="deletefile"></MdDelete> 
                                                <FaAngleRight id="next_img" onClick={handlenextcontract} className="deletefile">{">"}</FaAngleRight>
                                                <FaAnglesRight id="last_img" onClick={handlelastcontract} className="deletefile">{">"}</FaAnglesRight>
                                            </div>
                                        </center>
                                    </div>
                                </div> */}

                            </div>
                            <div id="idcards" className='UserTabs idcardtablesplit' style={rights !== 2 ? { display: "none" } : { display: "block" }}>
                                <div id="preview" className='kader' style={data.user.id === undefined ? { visibility: "hidden" } : { visibility: "visible" }}>
                                    <FileViewer

                                        fileUrl={idcard}
                                        height={300}           // keeps the viewer inside 300px height with scroll
                                        maxWidth={300}         // optional: cap page width
                                        renderAllPages={true}  // or false for single-page with controls
                                        className="preview"
                                    />

                                    {/* <label id="idcardstatus" style={typeof idcard === "string" ? { display: "none" } : { display: "block" }}>Nog geen identiteitskaart opgeladen</label> */}
                                    {/* <center> */}
                                    <div className='navbuttons'>
                                        <FaAnglesLeft id="first_img" onClick={handlefirstcontract} className="deletefile">{"<"}</FaAnglesLeft >
                                        <FaAngleLeft id="prev_img" onClick={handleprevcontract} className="deletefile">{"<"}</FaAngleLeft>
                                        <MdFileDownload id="open_img" onClick={openfile} className="deletefile"></MdFileDownload>
                                        <MdDelete id="delete_img" onClick={deletefilehandler} className="deletefile"></MdDelete>
                                        <FaAngleRight id="next_img" onClick={handlenextcontract} className="deletefile">{">"}</FaAngleRight>
                                        <FaAnglesRight id="last_img" onClick={handlelastcontract} className="deletefile">{">"}</FaAnglesRight>
                                    </div>
                                    {/* </center> */}
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel id="tabpanel_3" style={displaytabs.tab3 === false ? { display: 'none' } : null}>
                        <div className='tabpanel UserTabs' >
                            <div className="formElement">
                                <label>
                                    {t('Street')}:
                                </label>
                                <input id="straatnaam" type='text' name="straatnaam" value={data.user.straatnaam} onChange={events.changevalue} disabled={isDisabled}></input>
                            </div>
                            <div className="formElement gridform4Cols">
                                <label>
                                    {t('Nr')}:
                                </label>
                                <input id="huisnummer" type='text' className="halfwidth" name="huisnummer" value={data.user.huisnummer} onChange={events.changevalue} disabled={isDisabled} ></input>
                                <label>
                                    {t('Postbus')}:
                                </label>
                                <input id="bus" type='text' className="halfwidth" name="bus" value={data.user.bus} onChange={events.changevalue} disabled={isDisabled}></input>
                            </div>
                            <div className="formElement">
                                <label>
                                    {t('Community')}:
                                </label>
                                <input id="gemeente" type='text' name="gemeente" value={data.user.gemeente} onChange={events.changevalue} disabled={isDisabled}></input>
                            </div>
                            <div className="formElement">
                                <label>
                                    {t('ZipCode')}:
                                </label>
                                <input id="zipcode" type='number' name="zipcode" value={data.user.zipcode} onChange={events.changevalue} disabled={isDisabled}></input>
                            </div>
                            <div className="formElement">
                                <label>
                                    {t('Country')}:
                                </label>
                                <CountrieSelection isDisabled={isDisabled} data={{ fieldname: "land", land: data.user.land, handleitemchange: events.changevalue }} cssClass="countrySelection" />
                            </div>
                            <div className="formElement">
                                <label>
                                    {t('Phone')}:
                                </label>
                                <input id="gsm" type='Phone' name="gsm" value={data.user.gsm} onChange={events.changevalue} disabled={isDisabled}></input>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel id="tabpanel_4" style={displaytabs.tab4 === false ? { display: 'none' } : null}>

                        <div className='tabpanel UserTabs' id="Contractgegevens">

                            <div className="groupbox">
                                <label className='formtitleGroupBox'>Algemeen</label>
                                <div id="contractdiv" className="formElement gridform5Cols">
                                    <label>
                                        {t('Contract')}:
                                    </label>
                                    <input id="contract" type="text" name="contract" value={data.user.contract} disabled></input>
                                    <Button type="button" id="viewcontractButton" onClick={events.openContract} className="openContract">{t('Tooncontract')}</Button>
                                </div>
                                <div id="uploaddiv" className="formElement" style={!isDisabled ? null : { display: "none" }}>
                                    <label >
                                        {t('NieuwContract')}:
                                    </label>
                                    <input id="uploadContract" type='file' accept='.pdf' onChange={(e) => { events.setContract(e.target.files[0]); document.getElementById("viewcontractButton").disabled = true }} disabled={data.user.id === undefined ? true : isDisabled}></input>
                                </div>
                                <div className="formElement" Id="InService" style={data.user.nr_wkn <= 90000 ? { display: "block" } : { display: "none" }}>
                                    <label>
                                        {t('Afloopdatumcontract')}:
                                    </label>
                                    <DatePicker className='datepicker' id="afloopdatumcontract" placeholderText="dd/mm/yyyy" selected={data.user.afloopdatumcontract} onChange={(e) => events.changedate(e, "afloopdatumcontract")} showIcon name="afloopdatumcontract" dateFormat="dd/MM/yyyy" disabled={isDisabled} />
                                </div>
                                <div className="formElement" Id="InServiceLimosa" style={data.user.nr_wkn > 90000 ? { display: "block" } : { display: "none" }}>
                                    <label>
                                        {t('Afloopdatumlimosa')}:
                                    </label>
                                    <DatePicker className='datepicker' id="Afloopdatumlimosa" placeholderText="dd/mm/yyyy" selected={data.user.afloopdatumcontract} onChange={(e) => events.changedate(e, "afloopdatumcontract")} showIcon name="afloopdatumcontract" dateFormat="dd/MM/yyyy" disabled={isDisabled} />
                                </div>
                                <div className="formElement" Id="employer" >
                                    <label>
                                        {t('Employer')}:
                                    </label>
                                    <select id='employers' name="werkgever" value={data.user.werkgever} onChange={events.changevalue} disabled={isDisabled}>
                                        {employersarray}
                                    </select>
                                </div>
                            </div>

                            <div className="groupbox">
                                <label className='formtitleGroupBox'> {t('Details')}</label>
                                <div className="formElement contracttype">
                                    <label>
                                        {t('functie')}:
                                    </label>
                                    <select id='functie' name="functie" value={data.user.functie} onChange={events.changevalue} disabled={isDisabled}>
                                        <option >{t('SELECTFUNCTION')}</option>
                                        <option value={1}>{t('Medewerker Alg. Schoonmaak')}</option>
                                        <option value={2}>{t('Brigadier')}</option>
                                        <option value={3}>{t('Ploegchef')}</option>
                                        <option value={4}>{t('Overhead')}</option>
                                        <option value={5}>{t('Trainingsafgevaardigde')}</option>
                                        <option value={6}>{t('AllRoundMedewerker')}</option>
                                    </select>
                                </div>
                                <div className="formElement contracttype">
                                    <label>
                                        {t('Contracttype')}:
                                    </label>
                                    <fieldset id="contracttype" className="fieldset" onChange={events.setcontracttypevalue} disabled={isDisabled} value={data.user.contracttype}>
                                        <input type="radio" id="contracttype_1" name="contracttype" value={1} className="radio" />
                                        <label for="contracttype_1" className="radiolabel"> {t('Voltijds')}</label>
                                        <input type="radio" id="contracttype_2" name="contracttype" value={2} className="radio" />
                                        <label for="contracttype_2" className="radiolabel">{t('Deeltijds')}</label>
                                        <input type="radio" id="contracttype_3" name="contracttype" value={3} className="radio" />
                                        <label for="contracttype_3" className="radiolabel">{t('JobStudent')}</label>
                                    </fieldset>
                                </div>
                                <div className="formElement gridform7Cols" id="ContractualHours">
                                    <label>
                                        {t('Contracturen')}:
                                    </label>
                                    <label className='cur_label'>
                                        {t('weekly')}
                                    </label>
                                    <CurrencyInput
                                        className='CurrencyInput_100'
                                        id="Contracturen"
                                        name="contracturen"
                                        value={data.user.contracturen}
                                        placeholder="Please enter a number"
                                        defaultValue={36.50}
                                        decimalsLimit={2}
                                        decimalSeparator="."
                                        groupSeparator=","
                                        onChange={events.changevalue}
                                        disabled={isDisabled}
                                    />
                                    <label className='cur_label'>
                                        {t('monthly')}
                                    </label>
                                    <CurrencyInput
                                        className='CurrencyInput_100'
                                        id="contracturenMonthly"
                                        name="contracturenMonthly"
                                        value={data.user.contracturenMonthly}
                                        placeholder="Please enter a number"
                                        defaultValue={158.16}
                                        decimalsLimit={2}
                                        decimalSeparator="."
                                        groupSeparator=","
                                        onChange={events.changevalue}
                                        disabled={isDisabled}
                                    />
                                    {/* <select className="openContract" name="weekly_monthly" value={data.user.weekly_monthly} onChange={events.changevalue} disabled={isDisabled}>
                                        <option value="0">{t("weekly")}</option>
                                        <option value="1">{t("monthly")}</option>
                                    </select> */}
                                    {/* <input id="Contracturen" type='decimal' name="contracturen" value={data.user.contracturen} onChange={events.changevalue} disabled={isDisabled}></input> */}
                                </div>
                                <div className="formElement contracttype">
                                    <label>
                                        {t('Contractlooptijd')}:
                                    </label>
                                    <fieldset id="contractlooptijd" className="fieldset" onChange={events.setcontractlooptijdvalue} disabled={isDisabled} value={data.user.contractlooptijd}>
                                        <input type="radio" id="contractlooptijd_1" name="contractlooptijd" value={1} className="radio" />
                                        <label for="contractlooptijd_1" className="radiolabel">{t('Onbepaald')}</label>
                                        <input type="radio" id="contractlooptijd_2" name="contractlooptijd" value={2} className="radio" />
                                        <label for="contractlooptijd_2" className="radiolabel">{t('Bepaald')}</label>
                                        <input type="radio" id="contractlooptijd_3" name="contractlooptijd" value={3} className="radio" />
                                        <label for="contractlooptijd_3" className="radiolabel">{t('Beëindigd')}</label>
                                    </fieldset>
                                </div>
                                <div className="formElement" Id="div_starttime">
                                    <label>
                                        {t('Starttijd')} (hh:mm:ss):
                                    </label>
                                    <input id="starttime" type="text" name="starttime" defaultValue="10:10:00 am"
                                        useTwelveHourFormat={false} value={data.user.starttime} disabled={isDisabled} onChange={events.changevalue}></input>
                                </div>
                                <div className="formElement" Id="InService">
                                    <label>
                                        {t('Indienst')}:
                                    </label>
                                    <DatePicker className='datepicker' id="in_dienst" placeholderText="dd/mm/yyyy" selected={data.user.in_dienstdatum} onChange={(e) => events.changedate(e, "in_dienstdatum")} showIcon name="in_dienstdatum" dateFormat="dd/MM/yyyy" disabled={isDisabled} />
                                </div>
                                <div className="formElement" Id="OutService">
                                    <label>
                                        {t('Uitdienst')}:
                                    </label>
                                    <DatePicker className='datepicker' id="uit_dienst" placeholderText="dd/mm/yyyy" selected={data.user.uit_dienstdatum} onChange={(e) => events.changedate(e, "uit_dienstdatum")} showIcon name="uit_dienstdatum" dateFormat="dd/MM/yyyy" disabled={isDisabled} />
                                </div>
                            </div>

                            <div className="groupbox">
                                <label className='formtitleGroupBox'>Vrije dagen</label>
                                <div id="contractdiv" className="formElement gridform8Cols">
                                    <p className='daysofweek'>
                                    </p>
                                    <p className='daysofweek'>Ma</p>
                                    <p className='daysofweek'>Di</p>
                                    <p className='daysofweek'>Wo</p>
                                    <p className='daysofweek'>Do</p>
                                    <p className='daysofweek'>Vr</p>
                                    <p className='daysofweek'>Za</p>
                                    <p className='daysofweek'>Zo</p>
                                </div>
                                <div id="contractdiv" className="formElement gridform8Cols">
                                    <label>
                                        {t('nonworkindays')}:
                                    </label>
                                    <input id="maandag" type="checkbox" name="maandag" className='checkbox' value={data.user.maandag} checked={data.user.maandag} onChange={events.changecheckbox} disabled={isDisabled} ></input>
                                    <input id="dinsdag" type="checkbox" name="dinsdag" className='checkbox' value={data.user.dinsdag} checked={data.user.dinsdag} onChange={events.changecheckbox} disabled={isDisabled}></input>
                                    <input id="woensdag" type="checkbox" name="woensdag" className='checkbox' value={data.user.woensdag} checked={data.user.woensdag} onChange={events.changecheckbox} disabled={isDisabled}></input>
                                    <input id="donderdag" type="checkbox" name="donderdag" className='checkbox' value={data.user.donderdag} checked={data.user.donderdag} onChange={events.changecheckbox} disabled={isDisabled}></input>
                                    <input id="vrijdag" type="checkbox" name="vrijdag" className='checkbox' value={data.user.vrijdag} checked={data.user.vrijdag} onChange={events.changecheckbox} disabled={isDisabled}></input>
                                    <input id="zaterdag" type="checkbox" name="zaterdag" className='checkbox' value={data.user.zaterdag} checked={data.user.zaterdag} onChange={events.changecheckbox} disabled={isDisabled}></input>
                                    <input id="zondag" type="checkbox" name="zondag" className='checkbox' value={data.user.zondag} checked={data.user.zondag} onChange={events.changecheckbox} disabled={isDisabled}></input>
                                </div>
                                <div id="contractdiv" className="formElement gridform8Cols">

                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel id="tabpanel_5" style={displaytabs.tab5 === false ? { display: 'none' } : null}>
                        <div className='tabpanel UserTabs ' id="hotelselection">
                            <div className={viewOnly !== true ? hotelcss.hoteltableheader : hotelcss.hoteltableheader_view}>
                                <p id="Hotel_ID" style={viewOnly === true ? { display: "none" } : { display: "block" }}>{t('NR_Dep')}</p><p id="Hotel_Name"> {t('HotelName')}</p><p id="Linked" style={viewOnly === true ? { display: "none" } : { display: "block" }}>{t('Linked')}</p><p id="Linked" style={viewOnly === true ? { display: "none" } : { display: "block" }}>{t('supervisor')}</p><p id="24h" style={viewOnly === true ? { display: "none" } : { display: "block" }}>{t('24h')}</p></div>
                            <div className="listHeight">
                                <div id="hotelsList">
                                    {hotelsarray}
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel id="tabpanel_7" style={displaytabs.tab7 === false ? { display: 'none' } : null}>
                        <EmployeeHolidaysListNode t={t} user={data.user} viewOnly={viewOnly} />
                    </TabPanel>
                    <TabPanel id="tabpanel_8" style={displaytabs.tab8 === false ? { display: 'none' } : null}>
                        <div className={hotelcss.documenttableviewer}>
                            <div className='doctabpanel documentTabs' id="documentselection">
                                <div className={viewOnly !== true ? hotelcss.documenttableheader : hotelcss.documenttableheader}>
                                    <div onClick={adddocumentType} style={{ marginTop: '-18px', marginLeft: '5px' }} >
                                        <Tooltip id="adddoctype"></Tooltip><FaFolderPlus data-tooltip-id="adddoctype" data-tooltip-content={t('AddFolder')} />
                                    </div>
                                    <p id="filename" style={viewOnly === true ? { display: "none" } : { display: "block" }}>{t('filename')}</p><p id="date_uploaded" style={viewOnly === true ? { display: "none" } : { display: "block" }}>{t('date uploaded')}</p></div>
                                <div className="documentlistHeight">
                                    <div id="hotelsList">
                                        <TreeView id="treetest"
                                            rights={rights} translation={translation} events={{ getdocumentlist: getdocumentlist, loaddocumenttypes: loaddocumenttypes, cleariframe: cleariframe, EditdocumentType: EditdocumentType }}>
                                            {renderSubtrees(documenttree, data.user)}
                                        </TreeView>
                                    </div>
                                </div>
                            </div>
                            <div className='pdfspace'></div>
                            <div ><div className='filetitle' id="displayedfileName"></div><div className='pdfviewer'><iframe type="application/pdf" id="embedtag_new" className='pdfFile'></iframe></div></div>
                        </div>
                    </TabPanel>
                    <TabPanel id="tabpanel_9" style={displaytabs.tab9 === false ? { display: 'none' } : null}>
                        <div className={hotelcss.documenttableviewer}>
                            <div className='doctabpanel documentTabs' id="ziekteselection">
                                <div className={viewOnly !== true ? hotelcss.ziektetableheader : hotelcss.ziektetableheader}>
                                    <div onClick={addziektebriefje} style={{ marginTop: '-18px', marginLeft: '5px' }} ><Tooltip id="adddoctype"></Tooltip>
                                        <TiDocumentAdd data-tooltip-id="adddoctype" data-tooltip-content={t('Addillness')} />
                                    </div>
                                    <p id="date_uploaded" style={viewOnly === true ? { display: "none" } : { display: "block" }}>{t('Ingediend op')}</p>
                                    <p id="date_from" style={viewOnly === true ? { display: "none" } : { display: "block" }}>{t('Geldig van')}</p>
                                    <p id="date_till" style={viewOnly === true ? { display: "none" } : { display: "block" }}>{t('Geldig tot')}</p>
                                </div>
                                <div className="listHeight">
                                    <div id="ziekteList">
                                        {ziektearray}
                                    </div>
                                </div>
                            </div>
                            <div className='pdfspace'></div>

                            <div ><div className='filetitle' id="displayedziektefileName"></div><div className='pdfviewer'><iframe type="application/pdf" id="embedtag_ziekte" className='pdfFile'></iframe></div></div>
                        </div>
                    </TabPanel>
                </Tabs>
                <div id="editDiv" className="formchildButton" style={rights !== 2 & rights !== 4 ? { display: "none" } : null}>
                    <Button id="editButton" className='' style={rights !== 2 & rights !== 4 ? { display: "none" } : null} onClick={events.handleEdit}>{t('Edit')}</Button>
                </div>

                <div id="saveDiv" class="two_Buttons" style={rights !== 2 & rights !== 4 ? { display: "none" } : null}>
                    <Button type="submit" id="saveButton" className="Savebutton btn btn-primary margin-right">{t('Save')}</Button>
                    <Button type="button" id="cancelButton" className="Savebutton btn btn-primary margin-right" onClick={events.handleCancel} >{t('Cancel')}</Button>
                </div>

            </form>
            <div id="coverAll" className="subscreen" onMouseMove={events.MouseMove}>
                <AddDocumentType rights={rights} t={translation} id={typeid} description={typedescription} events={{ startdrag: events.startdrag, handleCancel: events.handleCancel, loaddocumenttypes: loaddocumenttypes }}></AddDocumentType>
                <AddDoctorsNote rights={rights} t={translation} user={data.user} doctorsnote={selectedZiekte} events={{ startdrag: events.startdrag, handleCancel: events.handleCancel, LoadDoctorsNotes: LoadDoctorsNotes }}></AddDoctorsNote>
            </div>
        </>
    );
}


export default EmployeeNode;
